import { baseState, baseMutations } from '@/store/mixins'
import year from '@/api/academic-year'
import term from '@/api/term-semester'
import mainProgram from '@/api/main-program'
import SubProgram from '@/api/sub-program'
import classOp from '@/api/class-operation'
import paymentStatistic from '../../api/payment-statistic'


export const state = {
    ...baseState
}
export const mutations = {
    ...baseMutations,
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
            },
            attrubutes
        )
        return paymentStatistic.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },

    getYear(context, option) {
        return paymentStatistic.academicYear(option)
            .then(response => response)
    },
    getTerm(context, attributes = {}) {
        return term.get({
            params: Object.assign(
                {
                    fields: {
                        academic_terms: 'ac_term_id,term_name,ac_status_id'
                    },
                    filter: {
                        ac_year_id: attributes
                    },
                    page: -1
                },
                attributes
            ),
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
    getMainProgram(context) {
        return mainProgram.get({
            params: {
                fields: {
                    academic_program_mains: 'acp_id,acp_name_foreign'
                },
                page: -1
            },
            header: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })

    },
    getSubProgram(context, attributes = {}) {
        return SubProgram.get({
            params: {
                fields: {
                    academic_program_subs: 'acps_id,acps_name_foreign'
                },
                page: -1
            },
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
    getClass(context, attributes = {}) {
        return classOp.get({
            params: Object.assign(
                {
                    include: 'teacher,academic_study_time',
                    fields: {
                        academic_classes: 'class_id,class_name,teacher_resp_id,ac_st_id',
                        teacher: 'teacher_id,fname_foreign,lname_foreign',
                        academic_study_time: 'ac_st_id,study_time'
                    },
                    page: -1
                },
                attributes
            ),
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
}